import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Switch, Redirect } from 'react-router-dom';
import SignIn from './signin/container/SignInContainer';
import { MyRoute } from './functions/RoutePath';
import history from './functions/history';
import { PrivateRoute } from './functions/PrivateRoute';
import InputContainer from './inputpage/container/InputContainer';
import MagneticContainer from './output/magnetic/container/MagneticContainer';
import AcousticContainer from './output/acoustic/container/AcousticContainer';
import SeismicContainer from './output/seismic/container/SeismicContainer';
import AdminPanelContainer from './admin/adminpanel/container/AdminPanelContainer';
import NewSystemContainer from './admin/newsystem/container/NewSystemContainer';
import EditSystemContainer from './admin/editsystem/container/EditSystemContainer';
import './App.css';
import { ROUTES } from './constants';

/**
 * Initialize and render the React Router application
 */
function initializeApp() {
  const routing = (
    <Router history={history}>
      <Switch>
        {/* Public Routes */}
        <MyRoute path={ROUTES.LOGIN} component={SignIn} />

        {/* Protected Routes - Inputs */}
        <PrivateRoute path={ROUTES.INPUTS} component={InputContainer} />

        {/* Protected Routes - Outputs */}
        <PrivateRoute path={ROUTES.OUTPUT.MAGNETIC}>
          <MagneticContainer />
        </PrivateRoute>
        <PrivateRoute path={ROUTES.OUTPUT.ACOUSTIC}>
          <AcousticContainer />
        </PrivateRoute>
        <PrivateRoute path={ROUTES.OUTPUT.SEISMIC}>
          <SeismicContainer />
        </PrivateRoute>

        {/* Protected Routes - Admin */}
        <PrivateRoute path={ROUTES.ADMIN}>
          <AdminPanelContainer />
        </PrivateRoute>
        <PrivateRoute path={ROUTES.SYSTEMS.NEW}>
          <NewSystemContainer />
        </PrivateRoute>
        <PrivateRoute path={ROUTES.SYSTEMS.EDIT}>
          <EditSystemContainer />
        </PrivateRoute>

        {/* Default redirect to login */}
        <Redirect to={ROUTES.LOGIN} />
      </Switch>
    </Router>
  );

  ReactDOM.render(routing, document.getElementById('root'));
}

// Initialize app
initializeApp();